import { MOCK_RECIPES } from '../../api/availableViews.mock';
import type { DefectCatalogItem } from '../../contracts/availableLayers';
import { mergeCrackmapCatalogDefects } from '../../crackmaps/mergeCrackmapCatalog';
import { mergeLineConditionCatalogDefects } from '../../lineConditions/mergeLineConditionCatalog';
import { mergePotholeCatalogDefects } from '../../potholes/mergePotholeCatalog';
import type { TenantDefectOverlayAdapter } from '../tenantDefectOverlayAdapter';

export const WINDSOR_OVERLAY_TENANT_SLUG = 'windsor';

export const WINDSOR_OVERLAY_RECIPE_IDS: ReadonlySet<string> = new Set([
  'pts-mfv-cracking',
  'pts-mfv-potholes',
  'pts-mfv-line-condition',
]);

function mergeWindsorCatalog(
  defects: readonly DefectCatalogItem[],
  surveyTypes?: readonly string[],
): readonly DefectCatalogItem[] {
  return mergeLineConditionCatalogDefects(
    mergePotholeCatalogDefects(
      mergeCrackmapCatalogDefects(defects, surveyTypes),
      surveyTypes,
    ),
    surveyTypes,
  );
}

export const windsorDefectOverlayAdapter: TenantDefectOverlayAdapter = {
  id: 'windsor-mfv-overlays',
  tenantSlug: WINDSOR_OVERLAY_TENANT_SLUG,
  recipeIds: WINDSOR_OVERLAY_RECIPE_IDS,
  mergeCatalog: mergeWindsorCatalog,
  getRecipes: () =>
    MOCK_RECIPES.filter((recipe) => WINDSOR_OVERLAY_RECIPE_IDS.has(recipe.id)),
};
